module.exports = "/images/azul-rojo.svg?6faa57a7ab0dd35e3047b64aa8b76028";